import React from 'react';

/** @internal */
export var meritIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 0C15.57 0 15.187 0.275 15.051 0.684L11.613 11H0.999976C0.570976 11 0.188976 11.274 0.0519759 11.681C-0.0850241 12.088 0.0529759 12.536 0.394976 12.796L8.86698 19.235L5.05098 30.684C4.91298 31.1 5.06098 31.558 5.41798 31.813C5.59198 31.938 5.79598 32 5.99998 32C6.21298 32 6.42698 31.932 6.60498 31.796L16 24.656L25.395 31.796C25.574 31.932 25.787 32 26 32C26.204 32 26.408 31.938 26.582 31.813C26.939 31.558 27.087 31.1 26.949 30.684L23.133 19.235L31.605 12.796C31.947 12.536 32.085 12.088 31.948 11.681C31.811 11.274 31.429 11 31 11H20.387L16.949 0.684C16.813 0.275 16.43 0 16 0ZM16 1L19.439 11.316L19.667 12H20.387H31L22.527 18.439L21.957 18.872L22.184 19.552L26 31L16.605 23.86L16 23.4L15.395 23.86L6 31L9.816 19.552L10.043 18.872L9.473 18.439L1 12H11.613H12.333L12.561 11.316L16 1Z"
}));